import React, { useState } from 'react';
import { EventDto, EventsStore } from 'stores/events/events-store';
import { RequestFormStore, RequestFormViewModel } from 'stores/requests/request-form-store';
import { connect } from 'redux-scaffolding-ts';
import { Modal } from 'semantic-ui-react';
import EventContainer from '../events/event-container';

interface RequestEventContainerProp {
  // extends RouteComponentProps
  request?: RequestFormViewModel;
  requestFormStore?: RequestFormStore;
  eventsStore?: EventsStore;
  fromRequestTab?: boolean;
}

const RequestEventContainer: React.FC<RequestEventContainerProp> = ({ request, requestFormStore, eventsStore, fromRequestTab }) => {
  const [openedEventForm, setOpenedEventForm] = useState<EventDto>(null);

  const { eventItem } = request;

  const handleOnEventClicked = (selectedEventId: string): void => {
    eventsStore.getById(selectedEventId).then(event => setOpenedEventForm(event));
  };

  return (
    <>
      <div
        onClick={() => {}}
        className={`bg-white shadow p-4 mt-4 overflow-y-auto transition-all duration-300 max-h-[300px]'
          }`}
      >
        <div key={`${eventItem.id}`} className="border-l-4 p-3 mb-2 cursor-pointer shadow-md">
          <p className="text-xs text-gray-500">{eventItem.friendlyId}</p>
          <div className="flex items-center gap-2" onClick={() => handleOnEventClicked(eventItem.id)}>
            <h4 className="text-black-600 font-semibold">{eventItem.title}</h4>
          </div>
          <p className="text-sm ">
            {eventItem.eventDetails.location
              ? eventItem.eventDetails.location.code !== 'XXXX' && eventItem.eventDetails.location.code !== 'XXXXX'
                ? eventItem.eventDetails.location.location + ' - ' + eventItem.eventDetails.location.countryName
                : eventItem.eventDetails.location.location
              : ''}
          </p>
        </div>
      </div>

      {openedEventForm && (
        <Modal size="large" open closeOnEscape={true} onClose={() => setOpenedEventForm(null)} closeOnDimmerClick={false}>
          <Modal.Content className="modal-content">
            <div>
              <EventContainer
                onBack={() => setOpenedEventForm(null)}
                onClose={() => setOpenedEventForm(null)}
                selectedEvent={eventItem}
                mode="ViewDetails"
                fromRequestTab={true}
                //onClose={this.onEditItemClosed}
                isOnlySupportDetailsEnabled={false}
                readOnlyForPocs={false}
              />
            </div>
          </Modal.Content>
        </Modal>

        /*
      <EventFormView
          event={buildEventViewModel(openedEventForm)}
          mode="ViewDetails"
          onClose={() => onCloseEventForm()}
          fromRequestTab={fromRequestTab}*/
      )}
    </>
  );
};

export default connect(['requestFormStore', RequestFormStore], ['eventsStore', EventsStore])(RequestEventContainer);
